import { useSyncExternalStore } from "react";
import { useNavigate } from "react-router-dom";
import { Crown } from "lucide-react";
import { api } from "@/lib/api";

let ids = new Set();
let loaded = false;
const subs = new Set();
const load = () => {
  if (loaded) return;
  loaded = true;
  api.get("/founders/ids").then(({ data }) => { ids = new Set(data); subs.forEach((f) => f()); }).catch(() => { loaded = false; });
};
const subscribe = (f) => { subs.add(f); load(); return () => subs.delete(f); };
export const useIsFounder = (id) => useSyncExternalStore(subscribe, () => Boolean(id) && ids.has(id));

export const FounderBadge = ({ userId, size = "sm", testId }) => {
  const on = useIsFounder(userId);
  const navigate = useNavigate();
  if (!on) return null;
  const lg = size === "lg";
  const go = (e) => { e.preventDefault(); e.stopPropagation(); navigate("/danke-stefan"); };
  return (
    <span role="link" tabIndex={0} onClick={go} onKeyDown={(e) => e.key === "Enter" && go(e)} title="Mitbegründer der itzPlay Community" data-testid={testId || `founder-badge-${userId}`}
      className={`founder-chip inline-flex items-center gap-1 shrink-0 whitespace-nowrap align-middle rounded-full font-extrabold tracking-wider cursor-pointer hover:scale-105 transition-transform ${lg ? "text-xs px-2.5 py-1" : "text-[10px] px-1.5 py-px ml-1"}`}>
      <Crown className={lg ? "w-3.5 h-3.5" : "w-2.5 h-2.5"} strokeWidth={2.5} /> Mitbegründer
    </span>
  );
};
